import React from 'react';
import {socialNetworks} from '../utilities/socialNetwork';
import './footer.style.scss';
import SocialItem from './socialItem';
const Footer = () => {
  return (
    <>
      <div className="flex w-full flex-col items-center gap-2 py-3 text-gray-700">
        <p className="w-full p-0 m-0 flex justify-center text-xs gap-1 items-center">
          اگر سوالی دارید میتوانید با
          <span className="text-sm">09352593515</span> تماس بگیرید.
        </p>
        <div className=" flex h-[1px] bg-gray-400 w-[60%]" />
        <div className="flex w-full justify-center gap-3">
          {React.Children.toArray(
            socialNetworks.map(item => (
              <SocialItem
                icon={item?.icon}
                title={item?.title}
                route={item?.route}
              />
            )),
          )}
        </div>
      </div>
    </>
  );
};

export default Footer;
